module.exports = __webpack_public_path__ + "img/1578973051.d03cc836.jpg";